<template>
  <div style="height: 100%;background-color: #fbfbfb">
    <div style="height: calc(100% - 20px);margin: 0 20px;padding-top: 20px">
      <el-row style="height: 100%;">
<!--        <el-col :span="4" style="height: 100%;">-->
<!--          <tree-organize ref="org" :treeObj="treeObj" @getOrgArr="getOrgArr"></tree-organize>-->
<!--        </el-col>-->
        <el-col :span="24" style="height: 100%;">
          <div style="height: 100%;">
            <div style="height: 50px;"><el-button type="primary" plain icon="el-icon-plus" @click="addStaff()">新建</el-button></div>
            <div style="max-height: calc(100% - 100px);overflow-y: auto">
              <el-table :data="tableData" border highlight-current-row ref="singleTable">
                <el-table-column
                  type="index"
                  label="序号"
                  width="70"
                  align="center">
                </el-table-column>
                <el-table-column
                  prop="service_personnel_name"
                  label="员工姓名"
                  min-width="60"
                  align="center">
                </el-table-column>
                <el-table-column
                  prop="newcard"
                  label="证件号码"
                  min-width="80"
                  align="center">
                </el-table-column>
                <el-table-column
                  label="性别"
                  min-width="60"
                  align="center">
                  <template slot-scope="scope">
                    <span v-if="scope.row.service_personnel_gender === '1'">男</span>
                    <span v-if="scope.row.service_personnel_gender === '2'">女</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="service_personnel_contact_number"
                  label="联系电话"
                  min-width="70"
                  align="center">
                </el-table-column>
                <el-table-column
                  label="所属组织"
                  min-width="60"
                  align="center">
                  <template slot-scope="scope">
                    <span>{{getOrgName(scope.row.orgid)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="文化程度"
                  min-width="70"
                  align="center">
                  <template slot-scope="scope">
                    <span>{{ getNameCulturalShow(scope.row.service_personnel_cultural_degree_code) }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop=""
                  label="岗位类型"
                  min-width="60"
                  align="center">
                  <template slot-scope="scope">
                    <span>{{ getNameJobCodeArr(scope.row.service_personnel_job_code) }}</span>
                  </template>
                </el-table-column>
<!--                <el-table-column-->
<!--                  prop=""-->
<!--                  label="在职状态"-->
<!--                  min-width="60"-->
<!--                  align="center">-->
<!--                </el-table-column>-->
                <el-table-column align="center" label="操作" width="120"  class-name="small-padding fixed-width">
                  <template slot-scope="scope">
                    <i title="详情" class="el-icon-view" style="cursor: pointer; font-size: 18px;color: blue" @click="seeStaff(scope.row)"></i>
<!--                    <i title="培训记录" class="el-icon-document" style="cursor: pointer; font-size: 18px;color: #d9ba6c" @click="seeRecords(scope.row)"></i>-->
                    <i title="编辑" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="editStaff(scope.row)"></i>
                    <i title="删除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delStaff(scope.row)"></i>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div style="margin-top: 10px;height: 40px;text-align: center">
              <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalCells"
                layout="total, sizes, prev, pager, next, jumper">
              </el-pagination>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-dialog :visible.sync="addShow" v-if="addShow" width="800px"
      :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <span>{{ showTitle }}</span>
        <div class="line-title"></div>
      </div>
      <add-staff :staffRow="staffRow" v-model="addShow" @updateTable="updateTable"></add-staff>
    </el-dialog>
    <el-dialog :visible.sync="detailsShow" v-if="detailsShow" width="750px"
               :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <span>员工详情</span>
        <div class="line-title"></div>
      </div>
      <details-info-open :staffRow="staffRow" v-model="detailsShow"></details-info-open>
    </el-dialog>
    <el-dialog :visible.sync="recordShow" v-if="recordShow" width="850px"
               :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <span>培训记录</span>
        <div class="line-title"></div>
      </div>
      <record-table :staffRow="staffRow" v-model="recordShow"></record-table>
    </el-dialog>
  </div>
</template>

<script>
import treeOrganize from './components/treeOrganize'
import addStaff from './components/addStaff'
import detailsInfoOpen from './components/detailsInfoOpen'
import recordTable from './components/recordTable'
import {queryserviceperson, deleteserviceperson} from '../../api/yanglaoyuan'
import {queryorg} from '../../api/organizer'

export default {
  name: 'institutionStaff',
  components: {treeOrganize, addStaff, detailsInfoOpen, recordTable},
  data () {
    return {
      loading: false,
      orgArr: [],
      // treeOrg: [],
      // treeNode: '',
      // treeObj: {
      //   orgData: [],
      //   isNo: true
      // },
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      tableData: [],
      educationArr: [],
      showTitle: '',
      addShow: false,
      staffRow: {
        entityArr: [],
        treeOrg: [],
        row: '',
        isAdd: true
      },
      detailsShow: false,
      recordShow: false,
      entityId: 0,
      jobCodeArr: []
    }
  },
  created () {
    this.jobCodeArr = this.commonType.getJobCodeArr()
    this.entityId = this.$store.state.user.LoginResp.entity_id
    this.educationArr = this.commonType.getEducationArr()
    this.getOrgData()
    this.getTableData()
  },
  methods: {
    getOrgData () {
      queryorg().then(res => {
        this.orgArr = res.data.org
        let treeData = []
        // 所属组织
        let lastLevel = 100
        const arr = this.orgArr
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].level < lastLevel) {
            lastLevel = arr[i].level
          }
        }
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].level === lastLevel) {
            treeData.push(arr[i])
          }
        }
        for (let i = 0; i < treeData.length; i++) {
          const child = this.arrayToNode(arr, treeData[i].id)
          if (child.length !== 0) {
            treeData[i].child = child
          }
        }
        this.staffRow.treeOrg = treeData
        console.log(13, treeData)
      }).catch(() => {})
    },
    // 递归
    arrayToNode (nodesArray, pid) {
      const vm = this
      return nodesArray.filter(value => {
        if (value.orgpid === pid) {
          const arrayToNode = vm.arrayToNode(nodesArray, value.id)
          if (arrayToNode.length > 0) {
            value.child = arrayToNode
          }
          return value
        }
      })
    },
    getOrgName (id) {
      let name = ''
      for (let i = 0; i < this.orgArr.length; i++) {
        if (this.orgArr[i].id === id) {
          name = this.orgArr[i].name
          if (this.orgArr[i].org_type === 2) {
            this.orgArr.forEach(item => {
              if (item.id === this.orgArr[i].orgpid) {
                name = item.name + '/' + name
              }
            })
          }
        }
      }
      return name
    },
    updateTable () {
      this.getTableData()
    },
    getTableData () {
      let params = {
        size: this.pageSize,
        page: this.currentPage
      }
      let data = {
        e_id: this.entityId
      }
      queryserviceperson(params, data).then(res => {
        this.tableData = res.data.serviceperson.filter(item => {
          item.newcard = this.formatIDCard(item.service_personnel_identity_card_number)
          return item
        })
        this.totalCells = res.data.cnt
      }).catch(() => {})
    },
    formatIDCard (card) {
      // 身份证号脱敏，展示前4后4
      return card !== '' ? card.replace(/^(.{4})(?:\d+)(.{4})$/, '$1**********$2') : ''
    },
    addStaff () {
      this.showTitle = '添加员工'
      this.staffRow.isAdd = true
      this.staffRow.row = ''
      this.addShow = true
    },
    editStaff (row) {
      this.showTitle = '编辑员工'
      this.staffRow.isAdd = false
      this.staffRow.row = row
      this.addShow = true
    },
    seeStaff (row) {
      this.staffRow.row = row
      this.detailsShow = true
    },
    seeRecords (row) {
      this.staffRow.row = row
      this.recordShow = true
    },
    delStaff (row) {
      let name = row.service_personnel_name
      this.$confirm('此操作将永久删除该机构人员【' + name + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          id: row.id
        }
        deleteserviceperson(data).then(res => {
          this.$notify({title: '成功', message: '成功删除机构员工', type: 'success', duration: 2000})
          if (this.tableData.length === 1 && this.currentPage > 1) {
            this.currentPage--
          }
          this.getTableData()
        }).catch(() => {})
      })
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.getTableData()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getTableData()
    },
    getNameCulturalShow (type) {
      let name = type
      for (let i = 0; i < this.educationArr.length; i++) {
        if (type === this.educationArr[i].id) {
          name = this.educationArr[i].name
        }
      }
      return name
    },
    getNameJobCodeArr (id) {
      let name = id
      for (let i = 0; i < this.jobCodeArr.length; i++) {
        if (id === this.jobCodeArr[i].id) {
          name = this.jobCodeArr[i].name
        }
      }
      return name
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/institutionStaff.vue